export const FETCH_SECTION_DRUG_COUNT_SUCCESS = 'FETCH_SECTION_DRUG_COUNT_SUCCESS';
export const FETCH_OUT_OF_STOCK_DRUGS_SUCCESS = 'FETCH_OUT_OF_STOCK_DRUGS_SUCCESS';
export const FETCH_DISPENSED_COUNT_SUCCESS = 'FETCH_DISPENSED_COUNT_SUCCESS';
export const FETCH_DISPENSED_PRESCRIPTIONS_SUCCESS = 'FETCH_DISPENSED_PRESCRIPTIONS_SUCCESS';
export const FETCH_DRUG_REVENUE_SUCCESS = 'FETCH_DRUG_REVENUE_SUCCESS';
export const FETCH_EXPIRED_DRUGS_SUCCESS = 'FETCH_EXPIRED_DRUGS_SUCCESS';

